<div class="row justify-content-end">
    @if (showCancelButton) {
        <div class="col-auto">
            <p-button [label]="l('::Cancel')" variant="outlined" (onClick)="onCancel()" />
        </div>
    }

    <div class="col-auto">
        <p-button [label]="l('::Save')" (onClick)="onSave()" [disabled]="isSaveDisabled" />
    </div>
</div>